import classNames from 'classnames';
import { memo, useCallback } from 'react';

import { CardSkeleton } from '../skeleton';
import type { TpPlanCardProps } from '../types';

import styles from './master.module.scss';

export const SubscriptionCardMaster = memo((props: TpPlanCardProps) => {
  const {
    descriptionContent,
    contentClassname,
    disabled,
    fullWidthBottomContent,
    inputIdPrefix,
    isCardSelected = false,
    leftBottomContent,
    onSelectPlan,
    plan,
    planCardClassname,
    prefix,
    rightContent,
    hideDescription,
    descriptionEndView,
  } = props;

  const namespace = `${inputIdPrefix ?? prefix}_subscription-plan-card`;
  const inputId = `${inputIdPrefix ?? prefix}${namespace}_${plan?.id}`;
  const isSelected = isCardSelected;

  const onChange = useCallback(
    () =>
      !isSelected &&
      onSelectPlan &&
      plan?.id != null &&
      onSelectPlan(plan.id, plan?.paddlePlanId),
    [onSelectPlan, plan?.id, plan?.paddlePlanId, isSelected],
  );

  const renderPlanName = useCallback(
    () =>
      plan?.hideDescription ||
      hideDescription ||
      plan?.description === null ? null : (
        <div
          className={classNames(styles.titleWrapper, {
            [styles.titleWrapperChecked]: isSelected,
            [styles.titleWrapperEnd]: descriptionEndView,
          })}
        >
          <h5 className={styles.titleCard}>
            <span>{plan?.description}</span>{' '}
            {descriptionContent && descriptionContent(isSelected)}
          </h5>
        </div>
      ),
    [
      descriptionEndView,
      descriptionContent,
      hideDescription,
      isSelected,
      plan?.description,
      plan?.hideDescription,
    ],
  );

  return plan ? (
    <li
      className={classNames(styles.wrapper, {
        [styles.wrapperDisabled]: disabled,
      })}
    >
      <input
        disabled={disabled}
        className={classNames(styles.input, {
          [styles.checked]: isSelected,
        })}
        type="radio"
        id={inputId}
        name={namespace}
        value={plan.id}
        checked={isSelected}
        onChange={onChange}
      />

      <div
        role="button"
        aria-pressed="false"
        onClick={onChange}
        className={classNames(
          disabled && styles.planCardDisabled,
          styles.planCard,
          planCardClassname,
        )}
      >
        {renderPlanName()}
        <div className={classNames(styles.content, contentClassname)}>
          <div className={styles.leftBlock}>
            <h4>{plan.name}</h4>
            {leftBottomContent && leftBottomContent(isSelected)}
          </div>
          <div className={styles.rightBlock}>
            {rightContent && rightContent(isSelected)}
          </div>
        </div>
        {fullWidthBottomContent && fullWidthBottomContent(isSelected)}
      </div>
    </li>
  ) : (
    <CardSkeleton />
  );
});

SubscriptionCardMaster.displayName = 'SubscriptionCardMaster';
